import * as types from './mutations-types'

export default {
  [types.setInvoice] (state, invoice) {
    state.invoice = invoice
  },
  [types.setYapayData] (state, yapayData) {
    state.yapayData = yapayData
  },
  [types.setPasswordYapay] (state, passwordYapay) {
    state.passwordYapay = passwordYapay
  },
  [types.setEmailYapay] (state, emailYapay) {
    state.emailYapay = emailYapay
  },
  [types.clearEmailYapay] (state) {
    state.emailYapay = ''
  },
  [types.clearPasswordYapay] (state) {
    state.passwordYapay = ''
  },
  [types.clearYapayData] (state) {
    state.yapayData = ''
  },
  [types.setSplits] (state, splits) {
    state.splits = splits
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/payments/vuex/mutations.js